<template>
  <div class="ma-4">
    <v-row>
      <v-col cols="12">
        <v-card class="pa-2" outlined tile height="100%">
          <v-tabs v-model="tab">
            <v-tabs-slider color="yellow"></v-tabs-slider>
            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(item, i) in items" :key="item">
              <v-card class="pa-2" outlined tile height="100%">
                <v-snackbar v-model="msg" top>
                  {{ text }}
                  <v-btn color="pink" text @click="msg = false">
                    Close</v-btn
                  ></v-snackbar
                >
                <v-data-table
                  :headers="headers"
                  :items="i === 0 ? units : inactiveUnits"
                  sort-by="Name"
                  sort-desc
                  class="elevation-1"
                  :loading="isLoading"
                  loading-text="Loading Programs"
                  :search="search"
                  height="578"
                >
                  <template v-slot:item.ShiftColor="{ item }">
                    <v-chip
                      :style="{
                        backgroundColor: item.ShiftColor,
                        color: 'white',
                      }"
                      class="ma-1"
                    >
                      {{ item.ShiftColor }}
                    </v-chip>
                  </template>
                  <template v-slot:item.select="">
                    <router-link to="/unitinfo">
                      <v-btn x-small class="primary"> select </v-btn>
                    </router-link>
                  </template>
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>PROGRAMS</v-toolbar-title>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="search"
                        clearable
                        flat
                        solo-inverted
                        hide-details
                        prepend-inner-icon="search"
                        label="search"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                      <v-dialog v-model="dialog" max-width="75%">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="#2b3990"
                            dark
                            class="mb-2"
                            v-on="on"
                            @click="showAdd()"
                          >
                            <v-icon left>add</v-icon>
                            Add Program</v-btn
                          >
                        </template>
                        <v-card>
                          <v-card-title style="background-color: #2b3990">
                            <span class="headline white--text">{{
                              titleForm
                            }}</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="newName"
                                    label="Program Name"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="newAddress"
                                    label="Address"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-text-field
                                    v-model="newCity"
                                    label="City"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-select
                                    label="State"
                                    v-model="newState"
                                    :items="states"
                                  ></v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                  <v-text-field
                                    v-model="newZip"
                                    label="Zip Code"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="newLatitude"
                                    label="Latitude"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" md="4">
                                  <v-text-field
                                    v-model="newLongitude"
                                    label="Longitude"
                                  ></v-text-field>
                                </v-col>
                                <v-col
                                  cols="12"
                                  sm="12"
                                  md="4"
                                  v-if="newState == 'Utah'"
                                >
                                  <v-autocomplete
                                    label="Location"
                                    v-model="newLocation"
                                    :items="locations"
                                  ></v-autocomplete>
                                </v-col>

                                <v-col class="d-flex" cols="12" sm="6">
                                  <v-autocomplete
                                    v-model="newHouseManager"
                                    :items="filteredUsers"
                                    item-text="Name"
                                    item-value="_id"
                                    label="House Manager"
                                    :loading="isLoadingUsers"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="6">
                                  <v-autocomplete
                                    v-model="newAssistantManager"
                                    :items="filteredUsers"
                                    item-text="Name"
                                    item-value="_id"
                                    label="Assistant Manager"
                                    :loading="isLoadingUsers"
                                  ></v-autocomplete>
                                </v-col>
                                <v-col cols="6" sm="6" md="6">
                                  Select Shift Color
                                  <v-color-picker
                                    v-model="newShiftColor"
                                    mode="hexa"
                                  ></v-color-picker>
                                </v-col>
                                <v-col cols="12" class="d-flex m-10">
                                  <v-switch
                                    :label="newStatus ? 'Active' : 'Inactive'"
                                    v-model="newStatus"
                                  ></v-switch>
                                  <span style="margin-right: 10px"></span>
                                  <v-switch
                                    class=""
                                    label="Set Geofence"
                                    v-model="setGeofence"
                                  ></v-switch>
                                  <v-responsive
                                    class=""
                                    style="margin-left: 10px"
                                    max-width="200"
                                  >
                                    <v-text-field
                                      v-model="setDistance"
                                      label="Set Radius (feet)"
                                      type="number"
                                    ></v-text-field>
                                  </v-responsive>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="#259647"
                              class="white--text"
                              @click="addUnit()"
                              v-if="newUnit"
                              >Save</v-btn
                            >
                            <v-btn
                              color="blue darken-1"
                              text
                              @click="updateUnit()"
                              v-if="editUnit"
                              >Update</v-btn
                            >
                            <v-btn color="blue darken-1" text @click="close"
                              >Cancel</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="viewUnit(item)">
                      mdi-eye
                    </v-icon>
                    <!-- <v-icon small class="mr-2" @click="editUnit(item)">
                      mdi-pencil
                    </v-icon> -->
                    <!-- <v-icon small @click="deleteUnit(item)">
                      mdi-delete
                    </v-icon> -->
                    <!-- <v-icon small @click="addDeal(item)">
                      add
                    </v-icon> -->
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="getUnits()">Reset</v-btn>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
    <Foot />
  </div>
</template>

<script>
import axios from "axios";
import Foot from "../components/Footer";
import Swal from "sweetalert2";

const url = require("../client_config/config").url;

export default {
  components: {
    Foot,
  },
  data: function () {
    return {
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "Name",
        },
        { text: "Address", value: "Address" },
        { text: "Location", value: "Location" },
        { text: "House Manager", value: "HouseManagerName.Name" },
        { text: "Assistant Manager", value: "AssistantManagerName" },
        { text: "Shift Color", value: "ShiftColor" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      dialog: false,
      editUnit: false,
      newUnit: false,
      msg: false,
      search: "",
      text: "",
      units: [],
      inactiveUnits: [],
      users: [],
      states: ["Utah", "Nevada"],
      locations: ["Southern Utah", "Northern Utah"],
      userID: localStorage.getItem("userID"),
      titleForm: "New Unit",
      unitID: "",
      newName: "",
      newCity: "",
      newState: "",
      newZip: "",
      newAddress: "",
      newLatitude: "",
      newLongitude: "",
      newLocation: "",
      newHouseManager: "",
      newAssistantManager: "",
      newStatus: true,
      setGeofence: "",
      typeColor: "hex",
      hex: "#FFFFFF",
      items: ["Active", "Inactive"],
      tab: null,
      editedIndex: -1,
      editedItem: {
        name: "",
        address: "",
        state: "",
        location: "",
        houseManager: "",
        assistantManager: "",
      },
      defaultItem: {
        name: "",
        address: "",
        state: "",
        location: "",
        houseManager: "",
        assistantManager: "",
      },
      isLoading: true,
      previousUnitValue: "",
      userState: localStorage.getItem("userState"),
      isLoadingUsers: true,
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex != 1 ? "New Item" : "Edit Item";
    },

    newShiftColor: {
      get() {
        return this[this.typeColor];
      },
      set(v) {
        this[this.typeColor] = v;
      },
    },
    filteredUsers() {
      let state = this.newState ? this.newState : this.userState;
      const users = this.users.filter((user) => user.State === state);
      return users;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    const companyIds = localStorage.getItem("userCompanies");
    this.getUnits(companyIds);
    this.getUsers();
  },

  methods: {
    initialize() {
      this.units = [];
    },
    viewUnit(item) {
      this.titleForm = "Viewing " + item.Name;
      this.dialog = true;
      this.editUnit = true;
      this.newUnit = false;
      this.newName = item.Name;
      this.newCity = item.City;
      this.newState = item.State;
      this.newZip = item.Zip;
      this.newLongitude = item.Longitude;
      this.newLatitude = item.Latitude;
      this.newAddress = item.Address;
      this.newLocation = item.Location;
      this.newHouseManager = item.HouseManager;
      this.newAssistantManager = item.AssistantManager;
      this.previousUnitValue = this.newName;
      this.newStatus = item.Status;
      this.setGeofence = item.SetGeofence;
      this.setDistance = item.SetGeofenceDistance;
      //this.showColor = item.ShiftColor;
      console.log(item.ShiftColor);
      if (item.ShiftColor == undefined) {
        this.newShiftColor = "#FFFFFF";
      } else {
        this.newShiftColor = item.ShiftColor;
      }

      this.unitID = item._id;
    },
    showAdd() {
      this.titleForm = "New Unit";
      this.newUnit = true;
      this.editUnit = false;
    },

    deleteUnit(item) {
      const id = item._id;
      confirm("Are you sure you want to delete this unit?") &&
        this.unitDelete(id);
    },

    unitDelete(id) {
      axios.delete(`${url}/units/${id}`).then((response) => {
        this.getUnits();
        if (response.status == 400) {
          response.json().then(function (data) {
            return data.msg;
          });
        }
        this.msg = true;
        this.text = "The unit has been deleted successfully.";
      });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.newName = "";
      this.newAddress = "";
      this.newState = "";
      this.newCity = "";
      this.newZip = "";
      this.newLatitude = "";
      this.newLongitude = "";
      this.newLocation = "";
      this.newHouseManager = "";
      this.newAssistantManager = "";
      this.newStatus = true;
    },

    updateUnit() {
      var req_body = {
        Name: this.newName,
        Address: this.newAddress,
        City: this.newCity,
        State: this.newState,
        Zip: this.newZip,
        Longitude: this.newLongitude,
        Latitude: this.newLatitude,
        Location: this.newLocation,
        HouseManager: this.newHouseManager,
        AssistantManager: this.newAssistantManager,
        ShiftColor: this.newShiftColor,
        PreviousUnitValue: this.previousUnitValue,
        Status: this.newStatus,
        SetGeofence: this.setGeofence,
        SetGeofenceDistance: this.setDistance,
      };
      axios.put(`${url}/units/${this.unitID}`, req_body).then((response) => {
        this.getUnits();
        if (response.status == 400) {
          response.json().then(function (data) {
            Swal.fire("Error", data.msg, "error");
          });
        }
        this.newName = "";
        this.newAddress = "";
        this.newCity = "";
        this.newState = "";
        this.newZip = "";
        this.newLatitude = "";
        this.newLongitude = "";
        this.newLocation = "";
        this.newHouseManager = "";
        this.newAssistantManager = "";
        this.newShiftColor = "#FFFFFF";
        this.setGeofence = "";
        Swal.fire(
          "Success",
          "The unit has been updated successfully.",
          "success"
        );
      });
      this.close();
    },
    getUnits: function (companyIds) {
      this.isLoading = true;
      axios
        .get(`${url}/units/status/company`, {
          params: {
            Company: companyIds, // Pass an array directly; axios will handle serialization
          },
        })
        .then((res) => {
          this.units = res.data.units; // Active units
          this.inactiveUnits = res.data.inactiveUnits; // Inactive units
        })
        .catch((error) => {
          console.error("Error fetching units:", error);
        })
        .finally(() => (this.isLoading = false));
    },
    getUsers: function () {
      this.isLoadingUsers = true;
      axios
        .get(`${url}/users`)
        .then(async (res) => {
          this.users = res.data.users;
          this.isLoadingUsers = false;
        })
        .catch((e) => {
          console.log(e.response);
          this.isLoadingUsers = false;
        });
    },

    addUnit: function () {
      var req_body = {
        Name: this.newName,
        Address: this.newAddress,
        City: this.newCity,
        State: this.newState,
        Zip: this.newZip,
        Longitude: this.newLongitude,
        Latitude: this.newLatitude,
        Location: this.newLocation,
        HouseManager: this.newHouseManager,
        AssistantManager: this.newAssistantManager,
        ShiftColor: this.newShiftColor,
        Status: this.newStatus,
        SetGeofence: this.setGeofence,
        SetGeofenceDistance: this.setDistance,
      };

      axios.post(`${url}/units`, req_body).then((res) => {
        this.getUnits();
        if (res.status == 400) {
          res.json().then(function (data) {
            this.text = data.msg;
          });
        }
        this.newName = "";
        this.newAddress = "";
        this.newState = "";
        this.newCity = "";
        this.newZip = "";
        this.newLatitude = "";
        this.newLongitude = "";
        this.newLocation = "";
        this.newHouseManager = "";
        this.newAssistantManager = "";
        this.newShiftColor = "#FFFFFF";
        this.newStatus = true;
        this.setGeofence = "";
        this.msg = true;
        this.text = "The new unit has been added successfully.";
      });
      this.close();
    },
  },
};
</script>
